const INSERT_IMAGE_BUTTON = "insert-image-button";
const PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON = "plugin-toolbar-button-image-editor";
const ROOT = "image-viewer";
const EXPAND_BUTTON = "image-expand-button";
const SETTINGS_MODAL = "image-settings-modal";
const SETTINGS_IMAGE_PREVIEW = "settings-image-preview";
const SETTINGS_ALT_INPUT = "settings-alt-input";
const SETTINGS_DISABLE_EXPAND_TOGGLE = "settings-expand-toggle";
const SETTINGS_DISABLE_DOWNLOAD_TOGGLE = "settings-download-toggle";
const SETTINGS_SPOILER_TOGGLE = "settings-spoiler-toggle";
const SETTINGS_IS_DECORATIVE_TOGGLE = "settings-is-decorative-toggle";
const SETTINGS_IMAGE_TABS = "settings-image-tabs";
const SETTINGS_DESIGN_TAB_BORDER_WIDTH_SLIDER = "settings-image-border-width-slider";
const SETTINGS_DESIGN_TAB_BORDER_WIDTH_INPUT = "settings-image-border-width-input";
const SETTINGS_DESIGN_TAB_BORDER_COLOR_PICKER = "settings-image-border-color-picker";
const SETTINGS_DESIGN_TAB_CORNER_RADIUS_SLIDER = "settings-image-corner-radius-slider";
const SETTINGS_DESIGN_TAB_CORNER_RADIUS_INPUT = "settings-image-corner-radius-input";
export {
  EXPAND_BUTTON,
  INSERT_IMAGE_BUTTON,
  PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON,
  ROOT,
  SETTINGS_ALT_INPUT,
  SETTINGS_DESIGN_TAB_BORDER_COLOR_PICKER,
  SETTINGS_DESIGN_TAB_BORDER_WIDTH_INPUT,
  SETTINGS_DESIGN_TAB_BORDER_WIDTH_SLIDER,
  SETTINGS_DESIGN_TAB_CORNER_RADIUS_INPUT,
  SETTINGS_DESIGN_TAB_CORNER_RADIUS_SLIDER,
  SETTINGS_DISABLE_DOWNLOAD_TOGGLE,
  SETTINGS_DISABLE_EXPAND_TOGGLE,
  SETTINGS_IMAGE_PREVIEW,
  SETTINGS_IMAGE_TABS,
  SETTINGS_IS_DECORATIVE_TOGGLE,
  SETTINGS_MODAL,
  SETTINGS_SPOILER_TOGGLE
};
//# sourceMappingURL=data-hooks.js.map
